export default __webpack_public_path__ + "static/media/640_store04-fr-web.d9033082.png";